module.exports = __webpack_public_path__ + "img/check-release.48384f46.svg";